// import httpClient from '../../utils/httpClient'
import auth from '../../utils/api/auth'
import user from '../../utils/api/user'

export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        getUser({commit}, data) {
            return user.getUser({token: data.token, userID: data.userID})
        },
        updateUser({commit}, data) {
            return user.updateUser({token: data.token, userID: data.userID, password: data.password})
        }
    }
}